import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PrivacySettingsState, privacySettingsFeatureKey } from '../reducers/privacy-settings.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as privacySettingsState from '../reducers/privacy-settings.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, PrivacySettingsState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region privacy settings SUB STATE
export const getPrivacySettingsState = createSelector(getMainEmployeeState, state => state[privacySettingsFeatureKey]);
//#endregion

//#region privacy settings SUB STATE
export const getPrivacySettingsRequest = createSelector(getPrivacySettingsState, privacySettingsState.getPrivacySettingsRequest);
export const getPrivacySettingsSuccess = createSelector(getPrivacySettingsState, privacySettingsState.getPrivacySettingsResponse);
export const getPrivacySettingsFailure = createSelector(getPrivacySettingsState, privacySettingsState.getPrivacySettingsFailure);

export const getPrivacySettingsIsloaded = createSelector(getPrivacySettingsState, privacySettingsState.getPrivacySettingsIsLoaded);
//#endregion
